<script setup lang="ts">
import { instance as api } from '@/helpers/api'
import { onMounted, ref, type Ref } from 'vue'
import { DownloadCountCollection } from '@/models/DownloadCount'
import { useRouter } from 'vue-router'
import KpTextfield from './kp-textfield.vue'
import type { DataTableHeader } from 'vuetify'

const impersonationEmail: Ref<string | null> = ref(null)
const openGesuchNr: Ref<string | null> = ref(null)
const downloadCountCollection = new DownloadCountCollection()
const headers: DataTableHeader[] = [
    { title: 'Datei', value: 'filename' },
    { title: 'Downloads', value: 'count' },
    { title: 'letzter Download', value: 'letzter_download' },
]

onMounted(async () => {
    await downloadCountCollection.query()
})

async function impersonate() {
    const res = await api().get('/auth/impersonateSession', {
        params: {
            userEmail: impersonationEmail.value,
        },
    })
    alert('You are now logged in as ' + res.data.benutzer.email + ', the page is reloaded.')
    document.location.reload()
}

const router = useRouter()
function openGesuch() {
    if (openGesuchNr.value) {
        router.push({ name: 'gesuch', params: { nr: openGesuchNr.value.toUpperCase() } })
    }
}
</script>

<template>
    <v-row>
        <v-card-title>Admin-Tools</v-card-title>
    </v-row>
    <v-row>
        <v-col>
            <v-card class="admin-card">
                <KpTextfield
                    style="width: 100%"
                    v-model="impersonationEmail"
                    label="User-Email:"
                    :onkeydown="(key: KeyboardEvent) => key.code === 'Enter' ? impersonate() : key"
                />
                <v-btn
                    class="mt-3 mr-4"
                    variant="tonal"
                    append-icon="fas fa-arrow-right"
                    @click="impersonate"
                    >zum User werden</v-btn
                >
            </v-card>
        </v-col>
        <v-col>
            <v-card class="admin-card">
                <KpTextfield
                    style="width: 100%"
                    v-model:model-value="openGesuchNr"
                    label="Gesuchs-Nr:"
                    :onkeydown="(key: KeyboardEvent) => key.code === 'Enter' ? openGesuch() : key"
                />
                <v-btn
                    class="mt-3 mr-4"
                    variant="tonal"
                    append-icon="fas fa-arrow-right"
                    @click="openGesuch"
                    >Gesuch öffnen</v-btn
                >
            </v-card>
        </v-col>
    </v-row>
    <v-row>
        <v-card-title> Download Zähler </v-card-title>
    </v-row>
    <v-row>
        <v-col>
            <v-card>
                <v-card-text>
                    <v-data-table :headers="headers" :items="downloadCountCollection.getModels()">
                        <template v-slot:[`item.letzter_download`]="{ item }">
                            {{ item.letzter_download?.format('DD.MM.YYYY HH:mm:ss') }}
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<style lang="css" scoped>
.admin-card {
    display: flex;
    align-items: end;
    flex-direction: column;
    padding: 2rem 1rem 2rem 2rem;
}
</style>
